import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { WelcomeComponent } from './welcome/welcome.component';
import { OnSignUpComponent } from './on-sign-up/on-sign-up.component';
import { LoadingComponent } from './loading/loading.component';
import { RouterModule, Routes } from '@angular/router';
import { BadSubscriptionComponent } from './bad-subscription/bad-subscription.component';
import { AuthService } from './auth.service';
import { AuthViewModel } from './auth.view-model';
import { AuthState } from './model/auth-state';
import { AuthCognitoService } from './auth-cognito.service';

export const authRoutes: Routes = [
  { path: AuthState.NO_ID, component: WelcomeComponent },
  { path: 'on-sign-up', component: OnSignUpComponent },
  { path: AuthState.BAD_SUBSCRIPTION, component: BadSubscriptionComponent },
  { path: AuthState.INITIALIZING, component: LoadingComponent },
];

@NgModule({
  declarations: [WelcomeComponent, OnSignUpComponent, LoadingComponent, BadSubscriptionComponent],
  imports: [CommonModule, SharedModule, RouterModule],
  providers: [AuthService, AuthViewModel, AuthCognitoService],
})
export class AuthModule {}
